(function() {
	angular.module('meanApp').controller('premiumCtrl', premiumCtrl);

	premiumCtrl.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'context',
		'httpAuth',
		'$state',
		'loginModal'
	];
	function premiumCtrl($scope, $rootScope, $location, context, httpAuth,$state, loginModal) {
		var vm = this;

		context.set({
			contextName: 'Page de paiement',
			title : 'Page de paiement',
			goBack: true
		});

		vm.goToCheckout = function() {
			// call to api here
			// price_1LzOkhFwZN5AyzAzIAuQj4X5
			// check if the user is connected
			console.log('email is', $rootScope.currentUser.email)
			if ($rootScope.currentUser.email) {
				httpAuth.post('/api/create-checkout-session/', {
					priceId: 'price_1LzOkhFwZN5AyzAzIAuQj4X5', //TODO put that price in a constant ?
					email: $rootScope.currentUser.email
				}, {
					headers: {
						"Content-Type": "application/json"
					}
				}).success(function(data) {
					window.open(data.data)
				})
			} else {
				loginModal.open(true)
			}
        }

		vm.manageSubscription = function() {
			window.open('https://billing.stripe.com/p/login/test_5kA3dG1h9dkZ0Y88ww')
		}
    }
})();
